import { render, staticRenderFns } from "./SpartanCarousel.vue?vue&type=template&id=b3a7fc60&scoped=true&"
import script from "./SpartanCarousel.vue?vue&type=script&lang=js&"
export * from "./SpartanCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SpartanCarousel.vue?vue&type=style&index=0&id=b3a7fc60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a7fc60",
  null
  
)

export default component.exports